module.exports = __webpack_public_path__ + "img/010086.66aba1c2.png";